import { render, staticRenderFns } from "./checkBoxRenovacion.vue?vue&type=template&id=6cddec4c&scoped=true"
import script from "./checkBoxRenovacion.vue?vue&type=script&lang=js"
export * from "./checkBoxRenovacion.vue?vue&type=script&lang=js"
import style0 from "./checkBoxRenovacion.vue?vue&type=style&index=0&id=6cddec4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cddec4c",
  null
  
)

export default component.exports